import { createContext, useState } from 'react'
import { WithChildren } from '_metronic/helpers'

interface Context {
  open: boolean
  currentPileHoleId: {
    pile1HoleId: string
    pile2HoleId: string
  }
  setOpen: (open: boolean) => void
  setCurrentPileHoleId: (value: { pile1HoleId: string; pile2HoleId: string }) => void
}

export const PileExecutionAttachmentContext = createContext<Context>({
  open: false,
  currentPileHoleId: {
    pile1HoleId: '',
    pile2HoleId: '',
  },
  setOpen: () => {},
  setCurrentPileHoleId: () => {},
})

export const PileExecutionAttachmentContextProvider: React.FC<WithChildren> = ({ children }) => {
  const [open, setOpen] = useState(false)
  const [currentPileHoleId, setCurrentPileHoleId] = useState({
    pile1HoleId: '',
    pile2HoleId: '',
  })

  return (
    <PileExecutionAttachmentContext.Provider
      value={{ open, currentPileHoleId, setOpen, setCurrentPileHoleId }}>
      {children}
    </PileExecutionAttachmentContext.Provider>
  )
}
